import { render, staticRenderFns } from "./TransactionDetailPopup.vue?vue&type=template&id=568d7444&"
import script from "./TransactionDetailPopup.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetailPopup.vue?vue&type=style&index=0&id=568d7444&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports